<template>
  <div class="secondary-color text-white">
    <div><img src="https://static.ezumee.com/ezumee/ezumee-logo-bg-white.png" style="width:25%;"/></div>
    <h3><i>Sumato&trade;</i></h3>
  </div>
</template>

<script>
export default {
  name: 'powered-by-sumato',
  data() {
    return {}
  }
};
</script>
